
import { computed, defineComponent, watch, PropType, ref } from "vue";
import { EditStore } from "@/stores";
import { consts } from "@/services/Models";

export default defineComponent({
  name: "EditTitle",
  props: {
    isShowModal: { type: Boolean },
    isSaveAs: { type: Boolean, default: false },
    editStore: { type: Object as PropType<EditStore> },
  },
  setup(props, context) {
    const isShow = computed({
      get: () => props.isShowModal,
      set: (newValue) => {
        context.emit("update:isShowModal", newValue);
      },
    });
    const title = ref(props.editStore?.state.editData.title);
    watch(isShow, () => (title.value = props.editStore?.state.editData.title));

    const setTitle = () => {
      if (title.value === undefined) {
        return;
      }
      context.emit("done", title.value);
    };

    return {
      isShow,
      title,
      setTitle,
      consts,
    };
  },
});
